/**
 * Created by USER on 18/6/25.
 */
import {ADD_PRODUCT, ADD_PAYMENT, ADD_PAYMENT_QRCODE} from '../actions/payment_action';

const initState = {
  order: null,
  payment: {},
  paymentQrcode: null
};

export default function paymentReducer(state = initState, action) {
  switch (action.type) {
    case ADD_PRODUCT:
      return Object.assign({}, state, { order: action.data});
    case ADD_PAYMENT:
      return Object.assign({}, state, { payment: action.data});
    case ADD_PAYMENT_QRCODE:
      return Object.assign({}, state, { paymentQrcode: action.data});
    default:
      return state;
  }
}
